export default __webpack_public_path__ + "static/media/00.3b47d30f.png";